import { Link } from 'react-router-dom';
import FeedbackForm from './components/FeedbackForm';

const highlights = [
  { icon: 'ri-book-2-line', title: '丰富漫画资源', desc: '覆盖动作、恋爱、奇幻等十余种题材，满足不同口味的读者。' },
  { icon: 'ri-filter-3-line', title: '精准分类筛选', desc: '按题材、地区、状态与更新时间交叉筛选，快速找到想看的作品。' },
  { icon: 'ri-book-open-line', title: '舒适阅读体验', desc: '整章图片顺序展示，支持字号调节与白天／夜晚模式切换。' },
  { icon: 'ri-heart-3-line', title: '收藏与追更', desc: '收藏作品、自动记录浏览历史，随时回到上次阅读的位置。' },
];

export default function About() {
  return (
    <div className="mx-auto max-w-[1280px] px-4 py-8 md:px-8">
      <title>关于抖漫 - 优质漫画阅读平台</title>
      <meta name="description" content="了解抖漫平台的定位、漫画资源版权声明与联系方式。抖漫致力于为漫画爱好者提供丰富的漫画资源与舒适的阅读体验。" />

      <nav className="mb-4 flex items-center gap-1.5 text-xs text-foreground-500">
        <Link to="/" className="transition hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-foreground-800">关于抖漫</span>
      </nav>

      <section className="overflow-hidden rounded-lg bg-accent-50 p-8 md:p-12">
        <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
          <i className="ri-sparkling-2-line" />
          关于抖漫
        </span>
        <h1 className="max-w-3xl font-heading text-3xl leading-snug text-foreground-950 md:text-4xl">
          让每一位漫画爱好者，都能轻松找到并追完心仪的作品
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">
          抖漫是一个专注于漫画阅读的在线平台，面向广大漫画爱好者，尤其是希望发现热门漫画、原创漫画及排行推荐的用户。
          我们希望通过清晰的分类、精准的筛选与舒适的阅读体验，帮助轻度和重度读者都能快速找到心仪作品。
        </p>
      </section>

      <section className="mt-10">
        <h2 className="mb-5 font-heading text-2xl text-foreground-950">我们提供什么</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {highlights.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
                <i className={item.icon} />
              </span>
              <h3 className="text-sm font-medium text-foreground-900">{item.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h2 className="mb-3 flex items-center gap-2 font-heading text-xl text-foreground-950">
            <i className="ri-copyright-line text-primary-500" />
            漫画资源版权声明
          </h2>
          <div className="space-y-3 text-sm leading-relaxed text-foreground-700">
            <p>
              抖漫平台目前展示的漫画名称、作者、简介与章节等内容均为<strong>演示示例数据</strong>，仅用于产品功能展示，不代表真实作品信息。
            </p>
            <p>
              平台的漫画阅读图片为一致的示例内容，不提供任何真实作品的下载、付费或传播服务。若相关权利人认为内容不妥，欢迎通过下方联系方式与我们沟通，我们将第一时间核实处理。
            </p>
            <p>请在合理范围内使用本站内容，尊重漫画创作者的版权与劳动成果。</p>
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h2 className="mb-3 flex items-center gap-2 font-heading text-xl text-foreground-950">
            <i className="ri-information-line text-primary-500" />
            功能与数据说明
          </h2>
          <ul className="space-y-2.5 text-sm text-foreground-700">
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
              搜索、筛选、分页均为前端演示逻辑，数据来自站内示例内容。
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
              收藏与浏览历史保存在你的浏览器本地，不会上传服务器。
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
              分享功能仅复制作品链接，不涉及任何第三方分享接口。
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
              本站不提供注册、登录、支付以及真实的下载与播放功能。
            </li>
          </ul>
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px]">
        <FeedbackForm />

        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h3 className="mb-4 font-heading text-xl text-foreground-950">联系我们</h3>
          <ul className="space-y-4 text-sm text-foreground-700">
            <li className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-mail-line" />
              </span>
              <span>
                <span className="block text-foreground-500">邮箱</span>
                <span className="text-foreground-900">hello@douman.example</span>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-wechat-line" />
              </span>
              <span>
                <span className="block text-foreground-500">微信公众号</span>
                <span className="text-foreground-900">抖漫漫画</span>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-time-line" />
              </span>
              <span>
                <span className="block text-foreground-500">响应时间</span>
                <span className="text-foreground-900">工作日 09:00 - 18:00</span>
              </span>
            </li>
          </ul>
          <Link
            to="/list"
            className="mt-6 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-compass-3-line" />
            去逛逛漫画库
          </Link>
        </div>
      </section>
    </div>
  );
}